import {
  VdChatInboxItem,
  VdChatMessage,
  VdChatMessagesResponse,
  VdChatUnreadCount,
  VdChatUploadUrlDto,
  VdSendChatMessageDto,
  VdUploadUrlResponse,
} from '../../types/deliveriesConsole';
import { ResponseType } from '../../types/shared.types';
import { api } from '../api';
import { vdOrgPath } from './base';

/*
 * One thread per driver, addressed by driverId; there is no "open
 * conversation" call and the deep link works before the first message.
 * Every active member sees every thread and they share one read state.
 */
const chatsPath = (orgId: number | string) => `${vdOrgPath(orgId)}/chats`;
const chatPath = (orgId: number | string, driverId: number | string) =>
  `${chatsPath(orgId)}/${driverId}`;

/** Every signed-up driver (applicants too), newest conversation first. */
export const vdGetChatInbox = (
  orgId: number | string,
  params: { query?: string; unreadOnly?: boolean } = {}
) =>
  api.get<ResponseType<VdChatInboxItem[]>>(chatsPath(orgId), { params });

export const vdGetChatUnreadCount = (orgId: number | string) =>
  api.get<ResponseType<VdChatUnreadCount>>(`${chatsPath(orgId)}/unread-count`);

export const vdGetChat = (orgId: number | string, driverId: number | string) =>
  api.get<ResponseType<VdChatInboxItem>>(chatPath(orgId, driverId));

/** Newest first; pass the previous `nextBeforeId` as `beforeId` for older. */
export const vdGetChatMessages = (
  orgId: number | string,
  driverId: number | string,
  params: { beforeId?: number; limit?: number } = {}
) =>
  api.get<ResponseType<VdChatMessagesResponse>>(
    `${chatPath(orgId, driverId)}/messages`,
    { params }
  );

/** Idempotent on `clientMessageId`; sending also marks the thread read. */
export const vdSendChatMessage = (
  orgId: number | string,
  driverId: number | string,
  data: VdSendChatMessageDto
) =>
  api.post<ResponseType<VdChatMessage>>(
    `${chatPath(orgId, driverId)}/messages`,
    data
  );

export const vdGetChatUploadUrl = (
  orgId: number | string,
  driverId: number | string,
  data: VdChatUploadUrlDto
) =>
  api.post<ResponseType<VdUploadUrlResponse>>(
    `${chatPath(orgId, driverId)}/upload-url`,
    data
  );

export const vdReadChat = (orgId: number | string, driverId: number | string) =>
  api.post<ResponseType<VdChatUnreadCount>>(`${chatPath(orgId, driverId)}/read`);
